import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

function PayPalConfirmPayment() {
    const [orderId, setOrderId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [responseMsg, setResponseMsg] = useState(null);
    const [paymentMethod, setPaymentMethod] = useState(null);
    const [total, setTotalAmount] = useState(null);
    const token = Cookies.get("Token");
    const navigate = useNavigate();

    useEffect(() => {
        const fetchUrlParams = () => {
            const urlParams = new URLSearchParams(window.location.search);
            setResponseMsg(urlParams.get("status"));
            setOrderId(urlParams.get("invoiceID"));
            setTotalAmount(urlParams.get("total"));
        };

        fetchUrlParams();

        setTimeout(() => setLoading(false), 15000);
    }, []);

    useEffect(() => {
        if (orderId && responseMsg) {
            processTransaction();
        }
    }, [orderId, responseMsg, paymentMethod]);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (responseMsg === "success") {
                navigate("/cssp");
            } else if (responseMsg !== "success") {
                navigate(`/invoice-detail/${orderId}`);
            }
        }, 20000);

        return () => clearTimeout(timer);
    }, [responseMsg, navigate, orderId]);

    const processTransaction = async () => {
        try {
            const status = responseMsg === "success" ? "COMPLETED" : "FAILED";
            // await saveTransactionToBackend(status, orderId);
        } catch (err) {
        }
    };

    // const saveTransactionToBackend = async (status, invoiceId) => {
    //     try {
    //         const response = await fetch(`${API_URL}/api/v1/create-transaction`, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 Authorization: `Bearer ${token}`,
    //             },
    //             body: JSON.stringify({
    //                 status: status === "COMPLETED" ? 1 : 0,
    //                 orderId: invoiceId,
    //                 amount: total,
    //                 gatewayId: 2,
    //                 type: 1,
    //                 transaction_id: invoiceId,
    //                 paymentMethod: "Paypal"
    //             }),
    //         });

    //         if (!response.ok) throw new Error("Failed to save transaction.");

    //         const result = await response.json();
    //     } catch (err) {
    //     }
    // };

    // Hiển thị vòng xoay khi đang loading
    if (loading) {
        return (
            <div className="loading-spinner">
                <div className="spinner"></div>
            </div>
        );
    }

    return (
        <div className="container">
            <div className="">
                <div className="payment-container">
                    <div className="payment-card">
                        {responseMsg === "success" ? (
                            <>
                                <p className="payment-status success">
                                    Trạng thái thanh toán: Thành công
                                </p>
                                <p className="payment-thankyou">
                                    Cảm ơn quý khách đã thanh toán. Đơn hàng của quý khách đang
                                    được xử lý. Xin vui lòng kiểm tra email để biết thêm chi tiết.
                                </p>
                                <button
                                    className="btn btn-primary mt-3"
                                    onClick={() => navigate("/cssp")}
                                >
                                    Trở về trang quản lý cssp
                                </button>
                            </>
                        ) : (
                            <>
                                <p className="payment-status pending">
                                    Vui lòng hoàn tất thanh toán hóa đơn của quý khách.
                                </p>
                                <button
                                    className="btn btn-primary mt-3"
                                    onClick={() => navigate(`/invoice-detail/${orderId}`)}
                                >
                                    Trở về trang đơn hàng
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PayPalConfirmPayment;
